export const downloadBlobAsFile = (params: { blob: Blob; filename: string }) => {
  const url = window.URL.createObjectURL(params.blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', params.filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
